module.exports = __webpack_public_path__ + "img/SES_4069004770.e195fb13.jpg";